import Container from "@/components/Container";
import Discounts from "./Discounts";
import MedicalReportPrompts from "./MedicalReportPrompts";
import InsightPrompts from "./InsightPrompts";
import ActionPrompts from "./ActionPrompts";
import InvitationForm from "../Shared/InvitationForm";
import CollapsibleList from "@/components/Collapsible/CollapsibleList";
import { ROLES } from "@/data/interfaces/RolesEnum";
import SupplementPrompts from "./SupplementPrompts";

const listItems = [
  {
    id: 1,
    label: "Pakviesti gydytoją",
    description: (
      <InvitationForm
        role={ROLES.DOCTOR}
        title="Pakviesti gydytoją"
        successMessage="Pakvietimas išsiųstas gydytojui"
      />
    ),
  },
  {
    id: 2,
    label: "Pakviesti pacientą",
    description: (
      <InvitationForm
        role={ROLES.USER}
        title="Pakviesti pacientą"
        successMessage="Pakvietimas išsiųstas pacientui"
      />
    ),
  },
  {
    id: 3,
    label: "Discounts",
    description: <Discounts />,
  },
  {
    id: 4,
    label: "Medical Report Prompts",
    description: <MedicalReportPrompts />,
  },
  {
    id: 5,
    label: "Health Insight Prompts",
    description: <InsightPrompts />,
  },
  {
    id: 6,
    label: "Action Plan Prompts",
    description: <ActionPrompts />,
  },
  {
    id: 7,
    label: "Supplement Prompts",
    description: <SupplementPrompts />,
  },
];

const AdminPanel = () => {
  return (
    <Container className="mt-8 mb-8 px-4">
      <h2 className="text-ink mb-4 text-2xl font-semibold">Administratorius</h2>

      <CollapsibleList data={listItems} />
    </Container>
  );
};

export default AdminPanel;
